import { APPROVAL_STATUS } from "../const/config";

export const getApprovalStatus = (approval = []) => {
  if (!approval.length) return APPROVAL_STATUS.INIT;
  const [first] = approval;
  return first.note ? APPROVAL_STATUS.REMAND : (first.status ? APPROVAL_STATUS.APPROVED : APPROVAL_STATUS.UNAPPROVED);
};